export default {
  // Login
  login: {
    lang: 'Idioma',
    systemname: 'Login',
    username: 'Usuário',
    username_label: 'Digite o usuário',
    pwd: 'Senha',
    pwd_label: 'Digite a senha',
    pwd_info: 'Insira uma senha válida',
    success_msg: 'Login bem-sucedido',
    error_name: 'Senha incorreta',
    error_res: 'Não atende aos requisitos de login',
    login: 'Entrar',
  },
  aside: {
    systemname: 'Painel',
    quit: 'Sair',
    deviceControl: 'Controle',
    basicSetting: 'Config.',
    workerSetting: 'Pessoas',
    deviceMonitoring: 'Monitor',
    recordManagement: 'Registros',
    securityManagement: 'Chaves',
    tips: 'Aviso',
    tips_msg: 'Deseja sair?',
  },
  control: {
    remoteControl: 'Remoto',
    restart: 'Reiniciar',
    clickToRestart: 'Clique para reiniciar',
    restartConfirm: 'Confirmar reinício?',
    restartSuccess: 'Reinício bem-sucedido',
    restartFailed: 'Reinício falhou',
    remoteOpen: 'Abrir porta remotamente',
    clickToOpen: 'Clique para abrir',
    openConfirm: 'Confirmar abertura remota?',
    remoteOpenSuccess: 'Abertura bem-sucedida',
    remoteOpenFailed: 'Abertura falhou',
    reset: 'Redefinir dispositivo',
    clickToReset: 'Clique para redefinir',
    resetConfirm: 'Confirmar redefinição?',
    resetSuccess: 'Redefinição concluída',
    resetFailed: 'Redefinição falhou',
    firmwareUpgrade: 'Atualizar firmware',
    upgradeConfig: 'Config. de atualização',
    firmwareUrl: 'URL do firmware',
    md5Checksum: 'Valor md5',
    startUpgrade: 'Iniciar atualização',
    urlRequired: 'URL é obrigatória',
    md5Required: 'md5 é obrigatório',
    urlInvalid: 'Informe uma URL válida',
    md5Invalid: 'Informe um md5 válido',
    upgradeConfirm: 'Confirmar atualização?',
    upgradeSuccess: 'Atualização bem-sucedida',
    clearFile: "Limpar arquivo",
    uploading: 'Enviando...',
    uploadAndUpgrade: 'Enviar e atualizar',
    restartTips: 'Reinício seguro, sem perder dados',
    restarting: 'Reiniciando...',
    remoteTips: 'Controle remoto de acesso',
    opening: 'Abrindo...',
    resetTips: 'Restaurar padrão, apagará dados',
    reseting: 'Redefinindo...',
    urlUpgrade: 'Atualização por URL',
    fileUpgrade: 'Atualização por arquivo',
    uploadFile: 'Clique para enviar firmware',
    formatFile: 'Suporta .zip ou .dpk, até 20MB',
    fileName: 'Nome do arquivo',
    size: 'Tamanho',
  },
  config: {
    second: 's',
    millisecond: 'ms',
    min: 'minutos',
    notsave: 'Não salvar',
    save: 'Salvar',
    noVoice: 'Sem voz',
    no: 'Não',
    yes: 'Sim',
    basicConfiguration: 'Configuração básica',
    displaySettings: 'Exibição',
    informationDisplay: 'Mostrar informações',
    audioSettings: 'Áudio',
    languageAndThemes: 'Idioma e tema',
    autoAdjustScreenBrightness: 'Brilho automático',
    screenBrightness: 'Brilho da tela',
    autoTurnOffScreen: 'Desligar tela automaticamente',
    autoTurnOffScreenTime: 'Tempo para desligar',
    autoScreenSaver: 'Protetor de tela automático',
    autoScreenSaverTime: 'Tempo do protetor',
    displayDeviceSn: 'Mostrar SN',
    displayIp: 'Mostrar IP',
    displayIdentityCard: 'Mostrar certificado em nuvem',
    volume: 'Volume',
    language: 'Idioma',
    displayCode: "Mostrar código da miniapp",
    themeMode: "Tema",
    cn: 'Chinês',
    en: 'Inglês',
    es: 'Espanhol',
    fr: 'Francês',
    de: 'Alemão',
    ru: 'Russo',
    ar: 'Árabe',
    pt: 'Português',
    ko: 'Coreano',
    standardMode: 'Modo padrão',
    simpleMode: 'Modo simples',
    firstLogin: 'Primeiro login',
    backlight: 'Luz de fundo',
    brightness: 'Luz branca',
    nirBrightness: 'Luz IR',
    never: 'Nunca',
    min1: '1 minuto',
    min2: '2 minutos',
    min3: '3 minutos',
    min4: '4 minutos',
    min5: '5 minutos',
    networkConfiguration: 'Rede',
    otherConfiguration: 'Outros',
    ipConfiguration: 'IP',
    devicePassword: 'Senha do dispositivo',
    protocolPassword: 'Senha do protocolo',
    networkType: 'Tipo de rede',
    ethernet: 'Ethernet',
    wifiName: 'Wi‑Fi',
    wifiPassword: 'Senha Wi‑Fi',
    dhcpModeSelection: 'Modo DHCP',
    dhcpMode: 'Automático',
    customNetworkConfiguration: 'Manual',
    ipAddress: 'Endereço IP',
    gateway: 'Gateway',
    subnetMask: 'Máscara de sub-rede',
    dnsServer: 'Servidor DNS',
    mac: 'MAC de rede',
    mqttRelatedConfiguration: 'MQTT',
    mqttConnectionInformation: 'Conexão MQTT',
    sessionConfiguration: 'Sessão',
    serverAddress: 'Servidor',
    clientID: 'ID do cliente',
    userName: 'Usuário',
    userPassword: 'Senha',
    topicPrefix: 'Prefixo do tópico',
    onlineChecking: 'Verificação online',
    onlineCheckingTimeout: 'Tempo limite',
    cleanSession: 'Sessão limpa',
    clientIdSuffix: 'Sufixo do ID',
    willTopic: 'Tópico Will',
    enterpriseWechat:'Modo WeChat Enterprise sem efeito',
    faceRelatedConfiguration: 'Config. de rosto',
    functionalInformation: 'Função',
    prompt: 'Aviso',
    faceSimilarityThreshold: 'Limite de similaridade',
    livenessDetectionFunction: 'Detecção de vivacidade',
    livenessDetectionThreshold: 'Limite de vivacidade',
    infraredImageDisplay: "Exibir infravermelho",
    maskRecognition: "Reconhecimento de máscara",
    strangerVoice: "Voz de desconhecido",
    voiceMode: "Modo de voz",
    voiceModeDate: 'Saudação personalizada',
    imageSaveType: "Tipo de salvamento",
    saveStrangerImage: "Salvar imagem de desconhecido",
    fullView: "Panorâmico",
    face: "Rosto",
    broadcastPleaseRegisterFirst: 'Reproduzir "Registre-se primeiro"',
    broadcastHelloStranger: 'Reproduzir "Desconhecido"',
    broadcastName: 'Reproduzir nome',
    broadcastGreeting: 'Reproduzir saudação personalizada',
    greeting: 'Saudação',
    broadcastWelcome: 'Reproduzir "Bem-vindo"',
    recognitionSwitch: 'Interruptor de re-detecção',
    systemRelatedConfiguration: 'Sistema',
    functionSwitch: 'Interruptores',
    cardSwipingSwitch: 'Cartão',
    passwordSwitch: 'Senha',
    strangerImage: 'Imagem de desconhecido',
    cloudCertificateSwitch: 'Certificado em nuvem',
    physicalCardNumber: 'Número do cartão físico',
    cloudCertificateAcquisition: 'Obter certificado em nuvem',
    heartbeatConfig: 'Heartbeat',
    heartbeatSwitch: 'Ativar heartbeat',
    heartRateInterval: 'Intervalo',
    heartbeatTopic: 'Tópico heartbeat',
    heartbeatContent: 'Conteúdo',
    basicInformation: 'Informações básicas',
    deviceMac: 'MAC',
    uuid: 'UUID',
    sn: 'SN',
    model: 'Modelo',
    version: "Versão",
    appVersion: "Versão do firmware",
    releaseTime: "Hora da atualização",
    totaldisk: 'Espaço total',
    freedisk: 'Espaço restante',
    passageConfiguration: 'Passagem',
    functionConfiguration: 'Funções',
    numberOfPassageRecords: 'Máx. registros',
    durationOfRelayOpening: 'Duração do relé',
    alarmSwitch: 'Alarme',
    fireAlarmSwitch: 'Alarme de incêndio',
    fireAlarmStatus: 'Status de incêndio',
    normal: 'Normal',
    warning: 'Alerta',
    tamperSwitch: 'Anti-violação',
    uploadToCloudSwitch: 'Interruptor de upload facial',
    clockConfiguration: 'Relógio',
    timeSynchronizationSwitch: 'Sincronizar hora',
    timeSynchronizationServerIP: 'Servidor de tempo',
    timedSynchronizationTime: 'Hora de sincronização',
    timeZone: 'Fuso horário',
    setDeviceTime: 'Ajustar hora',
    restartAfterSetting: 'O dispositivo reiniciará',
    cloudCertificateActivation: 'Ativar certificado',
    activationKey: 'Chave de ativação',
    cloudTips1: 'Digite a chave sem espaços',
    cloudTips2: 'Após ativar, conectará ao serviço em nuvem',
    confirmActivation: 'Confirmar ativação',
    activationInProgress: 'Ativando...',
    activationFailed: 'Falha na ativação',
    activationSuccessful: 'Ativação bem-sucedida',
    passwordModification: 'Alterar senha',
    password: 'Senha',
    oldPassword: 'Senha antiga',
    newPassword: 'Nova senha',
    confirmPassword: 'Confirmar senha',
    passwordRule: 'Recomendação de senha',
    passwordLength: 'Comprimento ≥6',
    cannotBeTheSame: 'Todos caracteres não podem ser iguais',
    cannotOrder: 'Sem 3+ números/letras consecutivos',
    cannotWeakPassword: 'Não usar senhas fracas comuns',
    submit: 'Enviar',
    saveConfig: 'Salvar',
    msg_please_enter: 'Por favor, insira',
    msg_inputPassword: 'Digite a senha',
    msg_oldPasswordError: 'Senha antiga incorreta',
    msg_password_mismatch: 'Senhas não coincidem',
    msg_password_min_length: 'Mínimo 6 caracteres',
    msg_is_weak_password: 'Senha fraca, altere',
    msg_pswChangeSuccessAndLogin: 'Senha alterada, faça login',
    msg_pswChangeSuccess: 'Senha alterada',
    msg_pswChangeFail: 'Falha ao alterar senha',
    msg_saveSuccess: 'Salvo com sucesso',
    msg_saveFail: 'Falha ao salvar',
    msg_formFilled: 'Verifique o formulário',
    msg_number_0_23: 'Apenas 0-23',
    msg_number_0_24: 'Apenas 0-24',
    msg_noChange: 'Nenhuma alteração de configuração para salvar',
    resourceConfiguration: 'Configuração de recursos',
    backgroundImage: 'Imagem de fundo',
    selectImage: 'Selecionar imagem',
    uploadBackground: 'Enviar fundo',
    uploading: 'Enviando...',
    backgroundUploadTip: 'Por favor, envie uma imagem em formato PNG com pixels de {n}, que será convertida para o formato Base64 e enviada ao dispositivo',
    backgroundResolutionMismatch: 'A resolução da imagem deve ser {n}',
    backgroundRequired: 'Selecione uma imagem de fundo',
    backgroundImageOnlyPNG: 'Apenas PNG',
    backgroundSizeLimit: 'Imagem não pode exceder 5MB',
    backgroundParseFailed: 'Falha ao ler imagem',
    backgroundImageSelected: 'Imagem selecionada',
    backgroundSuccess: 'Fundo enviado',
    backgroundFailed: 'Falha ao enviar fundo',
    scanSettings: 'Configurações de digitalização',
    scanSwitch: 'Interruptor de Digitalização',
    scanInterval: 'Intervalo de digitalização',
  },
  person: {
    idCard: 'Número de identificação',
    userType: 'Tipo de pessoa',
    administrator: 'Administrador',
    userId: 'ID',
    user: 'Usuário',
    voucher: 'Credencial',
    permission: 'Permissão',
    addUser: 'Adicionar pessoa',
    name: 'Nome',
    editUser: 'Editar pessoa',
    placeholderUserId: 'Informe o ID do usuário',
    placeholderName: 'Informe o nome',
    userNotExist: 'Pessoa não existe',
    oneClickClear: 'Limpar tudo',
    clearTips: 'Isto apagará todos os dados, continuar?',
    clearSuccess: 'Limpo com sucesso',
    clearFailed: 'Falha ao limpar',
  },
  voucher: {
    password: 'Senha',
    card: 'Cartão',
    face: 'Rosto',
    finger: 'Impressão digital',
    code: 'Código',
    codeType: 'Tipo de código',
    passthroughCode: 'Código de passagem',
    staticCode: 'Código estático',
    dynamicCode: 'Código dinâmico',
    placeholderCode: 'Por favor insira o certificado de código',
    placeholderPwd: 'Informe a senha',
    placeholderCard: 'Informe o cartão',
    validPassword: 'Insira 6 dígitos',
    validCard: 'Insira 8 dígitos ou letras',
    photoRegistration: 'Registro de foto',
    featureValueRegistration: 'Registro de características',
    fingerRegistration: 'Cadastro de digital',
    fingerFeatureRegistration: 'Cadastro por valor de característica',
    fingerInput: 'Coloque o dedo no leitor de digitais',
    fingerRemainingTime: 'Tempo restante',
    fingerInputting: 'Cadastrando...',
    startFingerInput: 'Iniciar cadastro de digital',
    fingerInputTips: 'Informe o valor de característica da digital',
    fingerWaitInput: 'Aguardando cadastro',
    fingerInputNow: 'Cadastrando digital...',
    fingerInputSuccess: 'Cadastro bem-sucedido',
    fingerInputFailed: 'Falha ao iniciar o cadastro de digital',
    fingerReTry: 'Falha no cadastro de digital, tente novamente',
    fingerFilled: 'Cadastro de digital bem-sucedido, o valor de característica foi preenchido automaticamente',
    fingerFailed: 'Falha no cadastro de digital',
    fingerTimeout: 'Tempo esgotado',
    fingerInputTimeout: 'Tempo esgotado no cadastro de digital, tente novamente',
    fingerError: 'Cadastro falhou',
    fingerInputError: 'Falha no cadastro de digital, tente novamente',
    fingerInputed: 'Digital já cadastrada',
    fingerReInput: 'Cadastrar digital novamente',
  },
  permission: {
    deletePermission: 'Excluir permissão',
    addPermission: 'Adicionar permissão',
    permissionId: 'ID da permissão',
    userId: 'ID do usuário',
    timeRange: 'Intervalo de tempo',
    extra: 'Extra',
    effectiveType: 'Tipo de vigência',
    effectiveTime: 'Tempo efetivo',
    effectiveWeek: 'Semana efetiva',
    timePeriod: 'Período',
    addTimePeriod: 'Adicionar período',
    modify_previous_time: 'Altere primeiro o período anterior',
    cannot_be_earlier: 'Hora final não pode ser menor que inicial',
    times_cannot_overlap: 'Horários não podem se sobrepor',
    choose_time_range: 'Selecione o intervalo',
    unlimitedMode: 'Ilimitado',
    usualMode: 'Modo usual',
    dailyMode: 'Modo diário',
    weeklyRepetitionMode: 'Repetição semanal',
    time_range: 'Faixa de tempo',
  },
  common: {
    startDate: 'Data inicial',
    endDate: 'Data final',
    to: 'a',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    close: 'Fechar',
    delete: 'Excluir',
    edit: 'Editar',
    batchDelete: 'Excluir em lote',
    startTime: 'Hora inicial',
    endTime: 'Hora final',
    monday: 'Segunda',
    tuseday: 'Terça',
    wednesday: 'Quarta',
    thursday: 'Quinta',
    friday: 'Sexta',
    saterday: 'Sábado',
    sunday: 'Domingo',
    placeholder: 'Por favor insira',
    placeholderSelect: 'Por favor selecione',
    closeTips: 'Confirmar fechamento?',
    deleteTips: 'Confirmar exclusão?',
    deleteSuccess: 'Excluído com sucesso',
    addSuccess: 'Adicionado com sucesso',
    editSuccess: 'Editado com sucesso',
    saveSuccess: 'Salvo com sucesso',
    tips: 'Dica',
    operation: 'Operação',
    query: 'Consulta',
    reset: 'Reset',
    noData: 'Sem dados',
    export: 'Exportar',
    success: 'Sucesso',
    failure: 'Falha',
    incorrectFormat: 'Formato incorreto',
    integerFormat: 'Deve ser inteiro ≥0',
    positiveIntegerFormat: 'Deve ser inteiro >0',
    noDataSaved: 'Sem dados para salvar',
    chinese: 'Chinês',
    english: 'Inglês',
    spanish: 'Espanhol',
    french: 'Francês',
    german: 'Alemão',
    russian: 'Russo',
    arabic: 'Árabe',
    portuguese: 'Português',
    korean: 'Coreano',
    detail: 'Detalhe',
    clearTips: 'Confirmar limpeza?',
    clearSuccess: 'Limpo com sucesso',
  },
  log: {
    accessMethod: 'Método de acesso',
    passingTime: 'Hora de passagem',
    accessPass: 'Credencial de acesso',
    accessResult: 'Resultado',
    accessPhoto: 'Foto',
    viewPhotos: 'Ver fotos'
  },
  error: {
    networkError: 'Falha de rede, verifique a conexão',
    timeout: 'Tempo esgotado, tente novamente',
    serverError: 'Erro interno, tente mais tarde',
    notFound: 'Recurso não existe',
    unauthorized: 'Não autorizado, faça login',
    noResponse: 'Sem resposta do servidor',
    unknownError: 'Falha na solicitação, código:',
    requestFailed: 'Solicitação falhou'
  },
  security: {
    keyId: 'ID da chave',
    keyType: 'Tipo de chave',
    keyEncoding: 'Codificação da chave',
    keyValue: 'Valor da chave',
    startTime: 'Hora de início',
    expirationTime: 'Hora de expiração',
    newKey: 'Adicionar chave',
    clearKey: 'Limpar chave',
    validTime: 'Tempo válido',
  }
}
